import Swiper, { Navigation } from "swiper";

const featureSwiper = new Swiper(document.querySelector(".featureSwiper"), {
  rewind: true,
  slidesPerView: 1,
  spaceBetween: 20,
  modules: [Navigation],
  pagination: {
    el: document.querySelector(".swiper-pagination"),
    dynamicBullets: true,
  },
  navigation: {
    nextEl: document.querySelector('.featureSwiper [data-next]'),
    prevEl: document.querySelector('.featureSwiper [data-prev]')
  },
  breakpoints: {
    768: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
  },
});

export default featureSwiper;
